module.exports = __webpack_public_path__ + "0d4643877b6956f8a3d87e1b62ab298a.pdf";